export const capitalizeFirstLetter = (value: string): string => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

/**
 * Remove caracteres não numéricos de uma string.
 *
 * @param value - A string a ser formatada.
 * @returns A string contendo apenas números.
 */
export const formatStringToNumber = (value: string): string => {
  if (!value) return value;
  const formattedValue = value.replace(/\D/g, "");
  return formattedValue;
};

/**
 * Função que trata possíveis casos de strings vazias ou com apenas espaços
 *
 * @param cpf - Valor da string
 * @returns Valor da string ou undefined
 */
export const stringOrUndefined = (value?: string): string | undefined => {
  if (!value) return undefined;

  const isStringWithOnlyEmptySpaces = value.trim() === "";

  return isStringWithOnlyEmptySpaces ? undefined : value;
};

/**
 * Normaliza um valor de texto para envio ao backend: strings vazias ou só com espaços
 * viram `null`, nunca string vazia. Aceita `null` para casar com os campos anuláveis
 * que vêm do GraphQL, algo que o `stringOrUndefined` não faz.
 *
 * @param value - Valor da string, possivelmente nulo ou indefinido.
 * @returns A string preenchida ou `null`.
 * @example
 * blankToNull("  "); // returns null
 * blankToNull(patient.nomePlano); // returns "Plano Ouro"
 */
export const blankToNull = (value?: string | null): string | null =>
  stringOrUndefined(value ?? undefined) ?? null;

/**
 * Remove diacríticos (acentos) de uma string.
 *
 * @param value - String original, contendo (ou não) diacríticos.
 * @returns Valor da string sem diacríticos.
 * @example
 * removeDiacritics("Coração"); // returns "Coracao"
 */
export const removeDiacritics = (value: string): string => {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
